const domainName = 'dev.rcscbs.com';

export const environment = {
  production: false,
  domainName,
  companyApiUrl: `https://company-api.${domainName}/api`,
  companyUrl: `https://company.${domainName}`,
  tpmUrl: `https://productionsystem.${domainName}`,
  listerUrl: `https://lister.${domainName}`,
  listerApiUrl: `https://lister-api.${domainName}/api`,
  posUrl: `https://pos.${domainName}`,
  donationUrl: `https://donation.${domainName}`,
  consignmentUrl: `https://consignment.${domainName}`,
  posApiUrl: `https://pos-api.${domainName}/api/`,
  inventoryApiUrl: `https://inventory-api.${domainName}/api`,
  productionSystemApiBaseUrl: `https://productionsystem-api.${domainName}/api`,
  enableOnlyWms: false,
};
